export default "__VITE_ASSET__DVkxkuzX__"